import Mustache from 'mustache'
import * as constants from './pbm.constants'

export class ModalPbmObserver {
    constructor(){
        this.modalContentElement = document.querySelector(".modal-pbm-content");
    }

    next(data) {
        if(this.modalContentElement) {
            const template = constants.templates[data.step];
            if(data.step && template.tpl) {
                //processa a template da etapa correspondente ao step
                Mustache.parse(template.tpl.textContent);
                this.modalContentElement.innerHTML = Mustache.render(template.tpl.textContent, data)

                //monta o component da etapa correspondente ao step
                if(template.component) {
                    const component = template.component(data);
                }
            }
        }

        //Open Modal Pbm
        const modalPbm = document.querySelector('.modal-pbm');
        if(modalPbm) {
            modalPbm.classList.add('modal--active')
            document.body.classList.add('block-scroll')
        }
    }

    error(){}
    complete(){}
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/modal-pbm.observer.js